module.exports = __webpack_public_path__ + "img/icon_aside_ppt4_active.c622e17a.svg";